var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vuestic-navbar",
    [
      _c("header-selector", {
        attrs: { slot: "selector", isOpen: _vm.valueProxy },
        on: {
          "update:isOpen": function ($event) {
            _vm.valueProxy = $event
          },
          "update:is-open": function ($event) {
            _vm.valueProxy = $event
          },
        },
        slot: "selector",
      }),
      _c(
        "span",
        { staticClass: "manage-logo", attrs: { slot: "logo" }, slot: "logo" },
        [_vm._v(_vm._s(_vm.VUE_APP_NAME) + "\n  ")]
      ),
      _c("span", { attrs: { slot: "center" }, slot: "center" }),
      _c("language-dropdown", { staticClass: "col nav-item" }),
      _c("profile-dropdown", { staticClass: "col nav-item nav-profile" }, [
        _c("img", { attrs: { src: _vm.headerIcon } }),
        _c("div", { staticClass: "nav-profile-info" }, [
          _c("span", [
            _vm._v("\n        " + _vm._s(_vm.merchant_name) + "\n      "),
          ]),
          _c("br"),
          _c("span", [
            _vm._v("\n        " + _vm._s(_vm.user_name) + "\n      "),
          ]),
          _c("br"),
          _c("span", [
            _vm._v("\n        " + _vm._s(_vm.merchant_no) + "\n      "),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }